
import crmService from "@/modules/CRM/services/crmService";

export default {
  name: "BuscaClienteContato",
  props: {
    label: {
      type: String,
      default: "Cliente ou contato",
    },
    placeholder: {
      type: String,
      default: "Busque por nome, telefone, e-mail ou documento",
    },
    incluirPessoas: {
      type: Boolean,
      default: true,
    },
    incluirContatos: {
      type: Boolean,
      default: true,
    },
    incluirOportunidades: {
      type: Boolean,
      default: false,
    },
    permiteCriarContato: {
      type: Boolean,
      default: true,
    },
    limit: {
      type: Number,
      default: 10,
    },
    value: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      contatos: [],
      erro: "",
      loading: false,
      modalCriarContato: false,
      novoContato: {
        nome: "",
        telefone: "",
      },
      oportunidades: [],
      pessoas: [],
      selecionado: this.value,
      termo: "",
      termoBuscado: "",
      timer: null,
    };
  },
  computed: {
    totalResultados() {
      return (
        this.contatos.length + this.pessoas.length + this.oportunidades.length
      );
    },
  },
  watch: {
    value(value) {
      this.selecionado = value;
    },
  },
  methods: {
    debouncedBuscar() {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => this.buscar(), 350);
    },
    async buscar() {
      const termo = (this.termo || "").trim();
      this.erro = "";
      this.termoBuscado = "";
      this.contatos = [];
      this.pessoas = [];
      this.oportunidades = [];

      if (termo.length < 2) {
        return;
      }

      this.loading = true;
      try {
        const requests = [];
        const requestTypes = [];

        if (this.incluirContatos) {
          requests.push(
            crmService.contatosAutocomplete({
              busca: termo,
              status: "Todos",
              limit: this.limit,
            })
          );
          requestTypes.push("contatos");
        }

        if (this.incluirPessoas) {
          requests.push(
            crmService.pessoasAutocomplete({
              busca: termo,
              limit: this.limit,
            })
          );
          requestTypes.push("pessoas");
        }

        if (this.incluirOportunidades) {
          requests.push(
            crmService.oportunidades({
              page: 1,
              per_page: this.limit,
              columnFilters: {
                contato: termo,
                status: "aberta",
              },
            })
          );
          requestTypes.push("oportunidades");
        }

        const responses = await Promise.all(requests);
        responses.forEach((response, index) => {
          const type = requestTypes[index];

          if (type === "contatos") {
            this.contatos = this.normalizeCollection(response.data);
          }

          if (type === "pessoas") {
            this.pessoas = this.normalizeCollection(response.data);
          }

          if (type === "oportunidades") {
            this.oportunidades = this.normalizeCollection(response.data);
          }
        });

        this.termoBuscado = termo;
      } catch (error) {
        this.erro = "Não foi possível buscar clientes e contatos.";
      } finally {
        this.loading = false;
      }
    },
    selecionar(tipo, item) {
      const selecionado = {
        tipo,
        label: this.itemLabel(tipo, item),
        id_crm_contato:
          tipo === "contato"
            ? item.id_crm_contato
            : item.id_crm_contato || null,
        id_pessoa: tipo === "pessoa" ? item.id_pessoa : item.id_pessoa || null,
        id_crm_oportunidade:
          tipo === "oportunidade" ? item.id_crm_oportunidade : null,
        raw: item,
      };

      this.selecionado = selecionado;
      this.$emit("input", selecionado);
      this.$emit("select", selecionado);
    },
    limpar() {
      this.selecionado = null;
      this.$emit("input", null);
      this.$emit("select", null);
    },
    abrirCriacaoContato() {
      this.novoContato = {
        nome: ((this.termo || "").trim() || this.termoBuscado || "").trim(),
        telefone: "",
      };
      this.modalCriarContato = true;
    },
    confirmarCriacaoContato() {
      const nome = (this.novoContato.nome || "").trim();
      const telefone = (this.novoContato.telefone || "").trim();

      if (!nome) {
        this.$toast.error("Informe o nome do contato.");
        return;
      }

      if (!telefone) {
        this.$toast.error("Informe o WhatsApp do contato.");
        return;
      }

      this.modalCriarContato = false;
      this.$emit("criar-contato", {
        nome,
        telefone,
        origem_criacao_rapida: true,
      });
    },
    normalizeCollection(data) {
      if (Array.isArray(data)) {
        return data;
      }

      if (data && Array.isArray(data.data)) {
        return data.data;
      }

      return [];
    },
    itemLabel(tipo, item) {
      if (tipo === "oportunidade") {
        return item.titulo;
      }

      return item.nome || item.nome_fantasia || item.email || "Sem nome";
    },
    tipoLabel(tipo) {
      const labels = {
        contato: "Contato CRM",
        pessoa: "Pessoa existente",
        oportunidade: "Oportunidade aberta",
      };

      return labels[tipo] || "Vínculo";
    },
    contatoDetalhe(contato) {
      return [contato.telefone, contato.email, contato.documento]
        .filter(Boolean)
        .join(" · ");
    },
    pessoaDetalhe(pessoa) {
      return [pessoa.nome_fantasia, pessoa.cnpj_cpf || pessoa.cpf]
        .filter(Boolean)
        .join(" · ");
    },
  },
};
